// extracted by mini-css-extract-plugin
export default {"modal":"Xka-z","header":"Yka-z","fields":"Zka-z","error":"_ka-z","disabled":"ala-z","reminderMsg":"bla-z","errorMsg":"cla-z","footer":"dla-z"};